import { render } from "./CustomerCaseDetial.vue?vue&type=template&id=68358942&scoped=true"
import script from "./CustomerCaseDetial.vue?vue&type=script&lang=js"
export * from "./CustomerCaseDetial.vue?vue&type=script&lang=js"

import "./CustomerCaseDetial.vue?vue&type=style&index=0&id=68358942&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68358942"]])

export default __exports__